
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { getAreaCount, getMachines } from '@/api/deviceManaging';
import { iDevice } from '@/interface/result';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import { iNetbar, eStatus } from '../../../interface/result';
@Component
export default class Status extends Mixins(GameArea, PageQuery) {
  private init = 0;
  private ispublic = 1;
  // private dynamComp = 'DeviceDetail';
  private pcStatuses = [
    {
      id: eStatus.NO,
      name: '全部',
    },
    {
      id: eStatus.FREE,
      name: '空闲',
    },
    {
      id: eStatus.OFFLINE,
      name: '离线',
    },
    {
      id: eStatus.MALFUCTIONED,
      name: '故障',
    },
    {
      id: eStatus.MAINTAIN,
      name: '维护',
    },
    {
      id: eStatus.USE,
      name: '使用',
    },
    {
      id: eStatus.USE_NO_ALLOT,
      name: '使用（暂停分配）',
    },
  ];
  private rowDetail: iNetbar = {
    id: 0,
    name: '',
    area_name: '',
    wan: '',
    isp: '',
    region_id: '',
    area_id: '',
    addr: '',
    uplink: '',
    cmd_port: 0,
    is_public: 0,
  };
  private generalTable = [];
  private switchArea(i: number) {
    this.init = i;
    this.getAreas();
    this.getCounts();
  }
  // 跳转到设备详情
  private goToDetails(row: iNetbar) {
    this.$router.push({
      name: 'device_import',
      params: {
        row: encodeURIComponent(JSON.stringify(row)),
      },
    });
  }
  showStatus(status: number) {
    if (status >= 0) {
      return this.pcStatuses.filter(item => item.id === status)[0].name;
    }
    return '未知';
  }
  private threeInOneQuery = '';
  private detailQuery = {
    search: '',
    regionid: 0, // 大区id
    configid: 0,
    status: -1,
    ispublic: 1,
  };
  private detailTable: iDevice[] = [];
  //获取数据种
  loading: boolean = false;
  searchList() {
    this.page_query.page = 1;
    this.getAllMachines();
  }
  /**
   * 改变选择
   */
  changeSelect() {
    this.searchList();
  }
  async getAllMachines() {
    this.loading = true;
    try {
      const res = await getMachines({ ...this.page_query, ...this.detailQuery });
      this.loading = false;
      if (res) {
        this.detailTable = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  async getCounts() {
    try {
      const areaid = this.init;
      const res = await getAreaCount({ areaid, ispublic: this.ispublic });
      if (res) {
        this.generalTable = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted() {
    this.pageFn = this.getAllMachines;
    this.getCounts();
    this.getAllMachines();
  }
}
